import HttpCMSAdapter from "./HttpCMSAdapter";
import httpClient from "common/HttpClient";

const create = () => {
  return new HttpCMSAdapter(httpClient);
};

const cmsAdapter = create();
export default cmsAdapter;
